const prefix = '/templates'

export const TEMPLATE_EDIT_URL = (id) => `${prefix}/${id}/edit`
export const TEMPLATE_CREATE_URL = () => `${prefix}/new`
export const TEMPLATE_INDEX_URL = () => `${prefix}`
